import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Qualifier } from "../../../../internal/qualifier/Qualifier.js";
/**
 * @description Defines the visual appearance of the background.
 * @memberOf Qualifiers.Background
 * @extends {SDK.Qualifier}
 */

var BackgroundQualifier = /*#__PURE__*/function (_Qualifier) {
  _inherits(BackgroundQualifier, _Qualifier);

  var _super = _createSuper(BackgroundQualifier);

  function BackgroundQualifier(backgroundValue) {
    var _this;

    _classCallCheck(this, BackgroundQualifier);

    // The qualifier key for this qualifier
    _this = _super.call(this, 'b'); // Such as color (b_red)

    if (backgroundValue) {
      _this.addValue(backgroundValue);
    }

    return _this;
  }

  return _createClass(BackgroundQualifier);
}(Qualifier);

export { BackgroundQualifier };